import { useEffect, useState, useRef } from 'react'
import BeatLoader from 'react-spinners/BeatLoader'
import QRCode from 'qrcode.react'
import isEmpty from 'lodash/isEmpty'

import { useSelector } from 'react-redux'

import { selectUserInfo } from 'redux/selector/user'

import { fetchDeviceQrcodeWithCache } from 'api/qrcode'
import useHintModal from 'hooks/useHintModal'

import {
  Wrapper,
  BgImg,
  QRCodeWrapper,
  TextBox,
  TextBoxTitle,
  BtnCopySharingUrl,
  Link,
  TextBoxId,
  TextBoxHint,
  Landing,
  BtnClose,
} from './Styled'
import { SAVE_ID_KEY } from 'constant/common'
import { useHtml2Image } from 'hooks/useHtml2Image'
import { getCachedShowId } from 'redux/saga/user'
// import html2canvas from 'html2canvas'

export default function IDCard({ onClose }) {
  const downloadLinkRef = useRef<HTMLAnchorElement | null>(null)
  const cardRef = useRef<HTMLDivElement | null>(null)
  const userInfo = useSelector(selectUserInfo)
  const [cachedShowId] = useState(getCachedShowId())
  const [url, setUrl] = useState<string | null | undefined>(null)
  const { closeHintModal } = useHintModal()
  const { downloadHtmlAsImage } = useHtml2Image()

  async function download() {
    const card = cardRef.current
    const imageName = userInfo?.show_id ?? cachedShowId ?? 'usercard'
    await downloadHtmlAsImage(card, imageName)
    localStorage.setItem(SAVE_ID_KEY, '1')
  }

  useEffect(() => {
    if (isEmpty(url)) return
  }, [url])

  useEffect(() => {
    fetchDeviceQrcodeWithCache().then((response) => {
      setUrl(response?.code)
    })
  }, [])

  return (
    <Wrapper>
      <BgImg
        ref={cardRef}
        onClick={download}
        data-testid="idcard_dialog_bg"
        aria-label="idcard_dialog_bg"
      >
        <QRCodeWrapper>
          {!!url ? (
            <QRCode id={'qrcode'} style={{ width: '100%', height: '100%' }} value={url} level={'H'} />
          ) : (
            <BeatLoader size={10} />
          )}
        </QRCodeWrapper>

        <TextBox>
          <TextBoxTitle>身份卡</TextBoxTitle>
          <TextBoxId data-testid="idcard_dialog_user_id" aria-label="idcard_dialog_user_id">
            用户:{userInfo?.show_id ?? cachedShowId}
          </TextBoxId>
          <TextBoxHint>
            用于找回帐号。建议保
            <br />
            存，请勿泄漏。
          </TextBoxHint>
        </TextBox>
        <BtnCopySharingUrl>截图保存图片</BtnCopySharingUrl>
        <Landing>官网地址：yuhuo.life</Landing>
      </BgImg>
      <BtnClose onClick={onClose ?? closeHintModal} />
      <Link ref={downloadLinkRef}></Link>
    </Wrapper>
  )
}
